import { render, staticRenderFns } from "./MisInscripciones2.vue?vue&type=template&id=e46c2caa"
import script from "./MisInscripciones2.vue?vue&type=script&lang=js"
export * from "./MisInscripciones2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports